var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'role-add'},"title":_vm.$t('setting.security.role.text')}}),_c('List',{attrs:{"dataList":_vm.roleDataList,"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[{name: 'status', color: true}],"fields":[ 
          ("name: " + (_vm.$t('setting.security.role.name'))), 
          ("name_en: " + (_vm.$t('setting.security.role.name-en'))), 
          ("status: " + (_vm.$t('setting.security.role.full-permission'))) ],"deletes":[_vm.deleted, null],"edit":{link: 'role-edit'},"filter":{
          search: ['roles.name', 'roles.name_en'],
          dropdown: []
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }